/* eslint-disable */
import listado from '../../../assets/js/ScriptListadoGeneral.js'

export default {
  data: () => ({
    planteles: [],
    pagina:'planteles',
    estatus:1,
    del: false,
    EstatusRegistro:'',
    idPlantel:'',
    permisoGuardar:0,
    permisoActivaInactivar:0,
    permisoEliminar:0,
    permisoConsultar:0,
    permisoAsignar:0
  }),
  methods: {

    ObtenerAcceso(){
    
      fetch(`${this.$BASE.baseUrl}api/ValidaAccesoFormulario`, {
        method: 'GET',
        headers: {
                  'Authorization': sessionStorage.getItem('token'),
                  'pagina':'listadoPlanteles'
                }
      })
      .then(rs => rs.json())
      .catch(error => console.log('error:', error))
      .then(rs => {

        if(rs.status == 427){
            this.$router.push('/'); 
        }
      });
    },
    ObtenerListaPlanteles(status){
      this.planteles = [];
      fetch(`${this.$BASE.baseUrl}api/ListadoPlanteles/${status}`, {
        method: 'GET',
        headers: {
                  'Authorization': sessionStorage.getItem('token'),
                  'pagina':'planteles',
                  'paginaOrigen':'listadoPlanteles'
                }
      })
      .then(rs => rs.json())
      .catch(error => console.log('error:', error))
      .then(rs => {
        if(rs.status == 200){
          rs.result.planteles.forEach(plantel=> {

            // Se itera sobre las propiedades de cada objeto Plantel, si hay una propiedad con valor
            // con valor null, se cambia a cadena vacía
            // para que sirva el SEARCH de la tabla
            for(let [key, value] of Object.entries(plantel)){
              if (value == null) {plantel[key] = '';}
            }
            this.planteles.push(plantel);
          });
          rs.result.permisos.forEach((item, indx) => {
                if (item.id == 1){ this.permisoGuardar = 1;}
                if (item.id == 3){ this.permisoActivaInactivar = 1;}
                if (item.id == 4){ this.permisoEliminar = 1;}
                if (item.id == 5){ this.permisoConsultar = 1;}
                if (item.id == 6){ this.permisoAsignar = 1;}
          });
       }
      });
    },
    ComboEstatus(){
      this.EstatusRegistro = [
            { text: 'Activo', value: 1, isSelected: false  },
            { text: 'Inactivo', value: 0, isSelected: false  },
            { text: 'Todos', value: 2, isSelected: false  }
        ]
    },
    CambiarStatus(id){
        listado.methods.CambiarStatus(id,this.pagina);
    },
    EliminarRegistro(){
        listado.methods.EliminarRegistro(this.idPlantel,this.pagina);
        this.del = false;
    },
    Consultar: function(event){
        this.planteles = [];
        this.ObtenerListaPlanteles(this.estatus);
    },
   },
  mounted(){
    this.ObtenerListaPlanteles(1);
    this.ComboEstatus();
     this.ObtenerAcceso();
  }
}
